import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

// Add global error handler to prevent alerts
window.addEventListener('error', (event) => {
  // Prevent default error handling
  event.preventDefault()
  // Log to console instead of showing alert
  console.error('Application error:', event.error)
  return true
})

// Also catch unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  event.preventDefault()
  console.error('Unhandled promise rejection:', event.reason)
  return true
})

export { application }
